var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCoderhouseBkg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 386,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.529 46.133c30.24-64.378 137.617-55.302 179.056-10.018 41.439 45.284 54.902 74.3 92.279 57.404 37.378-16.897 85.044-12.39 87.785 41.341 2.74 53.732-41.017 117.234-110.573 136.025-69.556 18.792-69.491 85.304-161.488 71.874-50.158-7.322-51.306-61.585-44.223-106.468C93.45 191.408 8.46 120.812 43.53 46.134z",
    fill: "#E9FE6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M43.529 46.133c30.24-64.378 137.617-55.302 179.056-10.018 41.439 45.284 54.902 74.3 92.279 57.404 37.378-16.897 85.044-12.39 87.785 41.341 2.74 53.732-41.017 117.234-110.573 136.025-69.556 18.792-69.491 85.304-161.488 71.874-50.158-7.322-51.306-61.585-44.223-106.468C93.45 191.408 8.46 120.812 43.53 46.134z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210 385.605c115.98 0 210-5.489 210-12.26 0-6.772-94.02-12.261-210-12.261S0 366.573 0 373.345c0 6.771 94.02 12.26 210 12.26z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M380.515 97.072H129.444v184.515h251.071V97.072z",
    fill: "#E9FE6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M380.515 97.072H129.444v184.515h251.071V97.072z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M380.515 97.072H129.444v11.296h251.071V97.072z",
    fill: "#E9FE6A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M373.572 105.768a3.043 3.043 0 100-6.086 3.043 3.043 0 000 6.086zM364.69 105.768a3.044 3.044 0 100-6.088 3.044 3.044 0 000 6.088zM355.811 105.768a3.044 3.044 0 10-.002-6.088 3.044 3.044 0 00.002 6.088z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M208.728 111.759h-77.17v165.008h77.17V111.759zM210.881 276.779h168.052V111.77H210.881v165.009z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M345.908 124.19H244.683v72.144h101.225V124.19z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M341.642 118.851H240.417v72.144h101.225v-72.144z",
    fill: "#E9FE6A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.653 118.851H240.417v72.144h101.236v-72.144z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M340.146 132.097H241.91v57.393h98.236v-57.393z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M341.642 118.851H240.417v11.296h101.225v-11.296z",
    fill: "#E9FE6A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M334.712 127.547a3.042 3.042 0 100-6.087 3.044 3.044 0 000 6.087zM325.828 127.547a3.043 3.043 0 10.001-6.087 3.043 3.043 0 00-.001 6.087zM319.981 124.504a3.04 3.04 0 01-1.879 2.811 3.04 3.04 0 01-4.149-2.218 3.042 3.042 0 012.985-3.637 3.03 3.03 0 012.814 1.877c.153.37.23.767.229 1.167z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M241.91 175.193l27.9-16.755 20.351 11.112 31.171-19.679 18.814 14.026v25.593H241.91v-14.297z",
    fill: "#E9FE6A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M270.375 147.358a7.584 7.584 0 01-9.061 7.436 7.586 7.586 0 01-5.956-5.957 7.578 7.578 0 017.436-9.061 7.583 7.583 0 017.581 7.582z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M251.161 181.898h-10.744v9.098h10.744v-9.098zM360.316 230.367H259.091v50.938h101.225v-50.938z",
    fill: "#000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M365.537 232.901H264.312v72.144h101.225v-72.144z",
    fill: "#E9FE6A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M365.537 232.901H264.312v72.144h101.225v-72.144z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M364.042 246.147h-98.236v57.393h98.236v-57.393z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M309.705 254.197l-7.788 23.481h-4.624l-5.806-17.33-5.903 17.33h-4.657l-7.744-23.481h4.527l5.838 17.838 6.076-17.838h4.019l5.935 17.946 6.011-17.946h4.116z",
    fill: "#B3B897"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M365.537 232.901H264.312v11.297h101.225v-11.297z",
    fill: "#E9FE6A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M361.647 238.557a3.037 3.037 0 01-1.879 2.811 3.04 3.04 0 01-4.149-2.218 3.037 3.037 0 012.985-3.637c.807 0 1.581.321 2.152.891.57.571.891 1.345.891 2.153zM352.755 238.557c0 .601-.178 1.19-.513 1.69a3.043 3.043 0 11.513-1.69zM343.876 238.557a3.045 3.045 0 01-5.196 2.152 3.039 3.039 0 01-.66-3.317 3.05 3.05 0 012.812-1.879 3.047 3.047 0 013.044 3.044z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M356.708 254.738h-42.381v1.083h42.381v-1.083zM356.708 260.315h-42.381v1.083h42.381v-1.083zM356.708 265.892h-42.381v1.084h42.381v-1.084zM356.708 271.47h-42.381v1.083h42.381v-1.083zM356.708 277.058h-42.381v1.083h42.381v-1.083zM356.698 282.637h-83.56v1.083h83.56v-1.083zM356.698 288.217h-83.56v1.083h83.56v-1.083zM356.698 293.793h-83.56v1.083h83.56v-1.083z",
    fill: "#B3B897"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M245.323 192.079H144.098v72.144h101.225v-72.144z",
    fill: "#000"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M249.665 184.487H148.44v72.144h101.225v-72.144z",
    fill: "#E9FE6A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M249.665 184.487H148.44v72.144h101.225v-72.144z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M248.172 197.732h-98.236v57.393h98.236v-57.393z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.767 220.109l-15.619 5.838 15.619 5.838v4.701l-20.861-8.091v-4.896l20.861-8.09v4.7zM204.231 203.679h5.047l-14.914 42.685h-5.058l14.925-42.685zM231.243 223.499v4.896l-20.882 8.091v-4.701l15.618-5.838-15.618-5.838v-4.7l20.882 8.09z",
    fill: "#B3B897"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M249.665 184.487H148.44v11.296h101.225v-11.296z",
    fill: "#E9FE6A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M245.768 190.14a3.042 3.042 0 01-5.199 2.148 3.045 3.045 0 013.33-4.959 3.036 3.036 0 011.869 2.811zM236.884 190.14a3.04 3.04 0 01-1.878 2.812 3.045 3.045 0 01-2.856-5.342 3.043 3.043 0 014.734 2.53zM228.004 190.14a3.047 3.047 0 01-1.878 2.812 3.043 3.043 0 111.878-2.812z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M121.069 174.763c-2.221 4.128-6.869 11.171-11.294 11.493 0 0-1.99 4.392 4.59 9.808 7.233 5.961 6.415-.743 6.415-.743-3.17-4.194-.66-7.043 2.296-9.23l-2.007-11.328z",
    fill: "#E4897B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M120.615 171.049c-2.279 5.779-3.914 9.082-2.411 13.276 2.246 6.341 10.395 7.01 14.358 2.014 3.575-4.491 6.704-13.21 2.237-18.015a8.484 8.484 0 00-7.852-2.594 8.493 8.493 0 00-6.332 5.319z",
    fill: "#E4897B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M117.015 180.543c1.181 2.7 11.559 4.31 14.449-2.782 0 0 5.391-1.321 7.868-5.35 2.477-4.029.949-7.431-2.419-8.62-2.964-1.09-3.881.297-3.881.297s-12.525-7.166-13.532-.668c-8.471 1.643-3.971 13.763-2.485 17.123z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M128.697 177.306a7.069 7.069 0 00-.198 4.517c.594 1.948 2.287 1.709 3.303.156.908-1.395 1.692-4.128.536-5.564-1.156-1.437-2.947-.834-3.641.891z",
    fill: "#E4897B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M107.85 186.661c.825-2.477 1.8-5.309 4.78-4.318 2.617.825 10.255 5.581 10.841 7.216a7.23 7.23 0 00-1.965 3.096l-13.656-5.994z",
    fill: "#E9FE6A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.85 186.661c.825-2.477 1.8-5.309 4.78-4.318 2.617.825 10.255 5.581 10.841 7.216a7.23 7.23 0 00-1.965 3.096l-13.656-5.994z",
    fill: "#FAFAFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.366 186.091a107.559 107.559 0 00-11.146 5.647 81.217 81.217 0 00-10.502 7.133c-.9.767-1.748 1.595-2.535 2.477-.751.826-1.428 1.652-2.114 2.428a151.455 151.455 0 00-3.797 4.954A125.518 125.518 0 0059.534 219l3.46 2.609 8.322-8.66a331.836 331.836 0 014.128-4.203 64.06 64.06 0 012.081-1.948 23.335 23.335 0 011.957-1.602c1.494-1.016 3.17-2.04 4.822-3.005a136.728 136.728 0 015.102-2.816c3.443-1.8 7.018-3.583 10.477-5.21l-3.517-8.074z",
    fill: "#DC897C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M59.715 229.05l2.09-3.724-6.416-1.932s-1.288 3.005.124 5.424l4.202.232z",
    fill: "#E4897B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M64.158 219.868l-4.095-1.329-4.649 4.855 6.39 1.932 2.354-5.458z",
    fill: "#E4897B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M100.642 183.796c-5.168-2.039-16.67 6.836-16.67 6.836l4.277 12.987a23.688 23.688 0 0010.8-5.54c5.639-4.929 6.885-12.17 1.593-14.283z",
    fill: "#E9FE6A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.154 193.556c-3.303 2.782-5.095 5.036-5.095 9.486l.19.578a23.733 23.733 0 0011.766-6.448l-6.861-3.616z",
    fill: "#000"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M79.911 233.17l32.77 5.87c1.329-2.766 4.169-12.673 9.585-24.637a179.053 179.053 0 014.954-10.073 127.955 127.955 0 016.861-11.261 87.097 87.097 0 00-10.461-3.171c-4.128-.924-17.066-5.878-20.864-6.25-5.02-.479-5.573 1.709-5.573 1.709s-6.729 7.076-17.272 47.813z",
    fill: "#E9FE6A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M122.267 214.402c1.461-3.245 3.121-6.605 4.954-10.073l-2.13-1.329s-4.954 7.489-2.824 11.402z",
    fill: "#000"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M162.895 209.664l4.228-.628-.488 6.663s-3.302.132-5.028-2.056l1.288-3.979z",
    fill: "#E4897B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M173.067 208.556l-1.56 5.722-4.871 1.42.479-6.663 5.952-.479z",
    fill: "#E4897B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M128.872 200.118c.107.653.206 1.132.313 1.652.108.52.232 1.057.364 1.585.256 1.049.528 2.081.825 3.121a50.295 50.295 0 002.254 6.143 36.914 36.914 0 003.303 5.961 20.878 20.878 0 005.284 5.333 14.413 14.413 0 003.781 1.808l.521.141.264.074.404.083a7.659 7.659 0 001.519.107 8.964 8.964 0 002.428-.388 16.717 16.717 0 003.534-1.569 26.13 26.13 0 002.823-1.899 51.76 51.76 0 008.983-8.95l-3.046-3.087a102.764 102.764 0 01-9.685 6.291c-.826.437-1.651.826-2.386 1.148a8.675 8.675 0 01-2.073.627c-.182.034-.37.034-.553 0-.041 0 0 0 0 0h.042l-.1-.041a6.505 6.505 0 01-1.775-.999 13.385 13.385 0 01-2.922-3.418 28.638 28.638 0 01-2.353-4.665 54.57 54.57 0 01-1.825-5.21 54.888 54.888 0 01-.743-2.7l-.322-1.354a83.546 83.546 0 01-.281-1.28l-8.578 1.486z",
    fill: "#DC897C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M124.139 199.706c-3.756 7.026 7.877 17.925 7.877 17.925l11.518-8.001a75.549 75.549 0 00-6.143-13.21c-4.607-7.554-10.387-2.064-13.252 3.286z",
    fill: "#E9FE6A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M126.989 367.964l6.695.702.339-3.881.916-10.56-6.695-.71-1.016 11.667-.239 2.782zM68.799 367.113h6.49l.321-1.462.041-.181 2.023-9.371.042-.19.776-3.592h-6.498l-3.195 14.796z",
    fill: "#E4897B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.244 353.515l-1.016 11.667 6.795-.397.916-10.56-6.695-.71zM68.987 366.294h.008l6.646-.825h.009l1.965-9.041h-.008l-6.597.512-1.965 9.065-.058.289z",
    fill: "#000"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.186 366.725h-7.885a.562.562 0 00-.553.446l-1.28 5.779a.976.976 0 00.95 1.156c2.551-.041 4.409-.198 7.612-.198 1.973 0 7.926.206 10.65.206 2.725 0 3.08-2.691 1.966-2.939-5.004-1.09-8.768-2.601-10.37-4.037a1.559 1.559 0 00-1.09-.413zM134.395 366.518h-7.885a.563.563 0 00-.553.445l-1.28 5.78a.978.978 0 00.95 1.156c2.551-.042 4.409-.198 7.612-.198 1.973 0 7.926.206 10.651.206 2.724 0 3.079-2.692 1.965-2.939-5.003-1.09-8.768-2.601-10.37-4.038a1.557 1.557 0 00-1.09-.412z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M135.551 362.159l-9.578.314c3.484-64.037 5.111-67.306-25.966-97.549-.727 9.148-1.544 18.634-2.345 26.544-.504 4.896-.66 9.173-1.47 12.31-5.531 21.211-18.849 58.744-18.849 58.744l-9.346.421s11.7-51.445 12.905-68.214c1.577-21.995-3.559-45.806-.636-63.021l32.646 5.54c29.607 43.33 35.031 52.692 22.639 124.911z",
    fill: "#E9FE6A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M135.551 362.159l-9.578.314c3.484-64.037 5.111-67.306-25.966-97.549-.727 9.148-1.544 18.634-2.345 26.544-.504 4.896-.66 9.173-1.47 12.31-5.531 21.211-18.849 58.744-18.849 58.744l-9.346.421s11.7-51.445 12.905-68.214c1.577-21.995-3.559-45.806-.636-63.021l32.646 5.54c29.607 43.33 35.031 52.692 22.639 124.911z",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M99.975 264.882c-.727 9.148-1.544 18.66-2.345 26.569-1.14-11.418-2.61-19.559-2.61-19.559s-1.345-1.106-5.044-7.01c-3.699-5.903 0-16.925 0-16.925-.082 10.238 9.999 16.925 9.999 16.925z",
    fill: "#000"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M136.625 361.126l-.471 2.683h-11.245v-2.477l11.716-.206zM78.45 362.158l-1.08 2.477H67.13l.19-2.477h11.13z",
    fill: "#E9FE6A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M136.625 361.126l-.471 2.683h-11.245v-2.477l11.716-.206zM78.45 362.158l-1.08 2.477H67.13l.19-2.477h11.13z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/logo-coderhouse-bkg.e519c6b5.svg";
export { SvgLogoCoderhouseBkg as ReactComponent };